import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, ExternalLink } from "lucide-react";
import { CLINIC, CONDITIONS } from "@/data/clinic";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img
              src={CLINIC.logoIcon}
              alt="Dr. Ashutosh Mishra clinic logo"
              className="w-12 h-12 rounded-2xl object-cover"
            />
            <div className="leading-tight">
              <div className="font-poppins font-semibold text-[19px] text-white">Dr. Ashutosh Mishra</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-green-300 font-medium">Diabetologist & Endocrinologist</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-slate-400">
            Senior diabetologist & endocrinologist in Varanasi with 20+ years of experience treating diabetes, thyroid, PCOS, obesity and hormonal disorders.
          </p>
        </div>

        <div>
          <h3 className="text-white font-poppins text-lg font-semibold mb-5">Treatments</h3>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/diabetologist-varanasi" className="hover:text-green-300" data-testid="footer-diabetologist">Diabetologist in Varanasi</Link></li>
            <li><Link to="/endocrinologist-varanasi" className="hover:text-green-300" data-testid="footer-endocrinologist">Endocrinologist in Varanasi</Link></li>
            {CONDITIONS.map((c) => (
              <li key={c.slug}>
                <Link to={`/${c.slug}`} className="hover:text-green-300 transition-colors" data-testid={`footer-treatment-${c.slug}`}>
                  {c.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-white font-poppins text-lg font-semibold mb-5">Quick Links</h3>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="hover:text-green-300">Home</Link></li>
            <li><Link to="/about-dr-ashutosh-mishra" className="hover:text-green-300">About Doctor</Link></li>
            <li><Link to="/blog" className="hover:text-green-300">Health Blog</Link></li>
            <li><Link to="/videos" className="hover:text-green-300">Educational Videos</Link></li>
            <li><Link to="/gallery" className="hover:text-green-300">Clinic Gallery</Link></li>
            <li><Link to="/patient-testimonials" className="hover:text-green-300">Patient Testimonials</Link></li>
            <li><Link to="/research-publications" className="hover:text-green-300">Research & Publications</Link></li>
            <li><Link to="/faqs" className="hover:text-green-300">FAQs</Link></li>
            <li><Link to="/contact" className="hover:text-green-300">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-poppins text-lg font-semibold mb-5">Contact</h3>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 text-green-400 shrink-0" /><span className="text-slate-400">{CLINIC.address}</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-green-400 shrink-0" /><a href={`tel:+91${CLINIC.phone}`} className="hover:text-green-300">{CLINIC.phoneDisplay}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 text-green-400 shrink-0" /><a href={`mailto:${CLINIC.email}`} className="hover:text-green-300">{CLINIC.email}</a></li>
            <li className="flex gap-3"><Clock className="w-4 h-4 mt-0.5 text-green-400 shrink-0" /><div className="text-slate-400">
              {CLINIC.hours.map((h) => <div key={h.day}><span className="text-slate-200">{h.day}:</span> {h.time}</div>)}
            </div></li>
            <li><a href={CLINIC.mapLink} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-green-300 hover:text-green-200">View on Google Maps <ExternalLink className="w-3 h-3" /></a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Dr. Ashutosh Mishra — Diabetes & Endocrinology Clinic, Varanasi. All rights reserved.</div>
          <div className="flex flex-wrap gap-5">
            <Link to="/privacy-policy" className="hover:text-green-300">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-green-300">Terms</Link>
            <Link to="/disclaimer" className="hover:text-green-300">Disclaimer</Link>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-green-300">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
